import { render, staticRenderFns } from "./QcPointTable.vue?vue&type=template&id=3889c67f&"
import script from "./QcPointTable.vue?vue&type=script&lang=js&"
export * from "./QcPointTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports